import { MdrCustomerPanelWebComponent } from './component/MdrCustomerPanelWebComponent';
import { WEB_COMPONENT_MDR_CUSTOMER_PANEL } from '../../webcomponents.constants';

export { MdrCustomerPanelWebComponent };

window.customElements.define(WEB_COMPONENT_MDR_CUSTOMER_PANEL, MdrCustomerPanelWebComponent);
